module.exports = __webpack_public_path__ + "static/logo-elior-25de164396a69102705975b4ecc79560.png";